import React from 'react';
import { EM_TAGS, EM_TONE } from '../../email/mockData';
import type { EmTagKey } from '../../email/types';
import { Icon } from '../Icon/Icon';

export function EmailTag({ tagKey, sm }: { tagKey: EmTagKey; sm?: boolean }) {
  const tag = EM_TAGS[tagKey];
  if (!tag) return null;
  const tn = EM_TONE[tag.tone];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: sm ? '1px 7px' : '2px 8px',
        borderRadius: 'var(--r-sm)',
        background: tn.bg,
        color: tn.fg,
        fontSize: sm ? 10 : 10.5,
        fontWeight: 600,
      }}
    >
      <Icon kind={tag.icon} size={sm ? 9 : 10} stroke={2.2} />
      {tag.label}
    </span>
  );
}
